import React from 'react';
// import PropTypes from 'prop-types';
import Lottie from '../ReactLottie';
import animationData from './animationData';

const requireContextImages = () => {
  const lottieImagesRequire = require.context(
    '@/assets/images/lottie/recordReading/',
    false,
    /\w+\.png$/,
  );
  return lottieImagesRequire.keys().map(e => lottieImagesRequire(e));
};

class RecordingReadingBtn extends React.PureComponent {
  static propTypes = {
    // callback: PropTypes.func,
  };

  state = {
    isStopped: true,
  }

  componentDidMount() {
    setTimeout(() => this.setState({ isStopped: false }), 0);
    // 点击暂停
    this.animation.handleClickToPause = null;
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: false,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    const lottieStyles = {
      overflow: 'hidden',
      margin: '0 auto',
      width: '100%',
      height: '100%',
    };
    const eventListeners = [
      {
        eventName: 'complete',
        // callback: () => this.props.callback(),
      },
    ];
    return (
      <Lottie
        ref={(e) => { this.animation = e; }}
        style={lottieStyles}
        options={defaultOptions}
        isStopped={this.state.isStopped}
        requireContextImages={requireContextImages}
        eventListeners={eventListeners}
        speed={1}
      />
    );
  }
}

export default RecordingReadingBtn;
